import React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import * as styles from "../styles/mosaicitem.module.css"

function MosaicItem(props) {
  const data = props.data
  const setLightboxOpenTitle = props.setLightboxOpenTitle
  const setLightboxOpenUrl = props.setLightboxOpenUrl
  const setLightboxOpen = props.setLightboxOpen

  function openLightbox(data) {
    setLightboxOpenUrl(data.url)
    setLightboxOpenTitle(data.title)
    setLightboxOpen(true)
  }

  return (
    <div
      role="button"
      tabIndex={0}
      className={styles.item}
      onClick={() => openLightbox(data)}
      onKeyDown={e => e.key === "Enter" && openLightbox(data)}
    >
      <GatsbyImage
        className={styles.logo}
        media={{ maxWidth: "576px" }}
        image={getImage(data.logo)}
        alt={data.title}
      />
      <span>{data.description}</span>
    </div>
  )
}

export default MosaicItem
